<!-- @if (infoNotesFormGroups()) {
  @for (infoNote of infoNotesFormGroups()?.controls ?? []; track infoNote; ) {
    <div [formGroup]="$any(infoNote)" class="flex flex-auto">
      @switch (infoNote.getRawValue().NoteType) {
                Τύπος Εγγραφής. Τύποι: 'FAX', 'MOBILE', 'LANDPHONE', 'EMAIL', 'IDENTITY' (Ταυτότητα π.χ Αστυνομική), 'CONTACTINFO' (Πρόσωπο Επικοινωνίας)
        @case ('NOTES') {
          <z-float-label-notes [formControlName]="'Note'"></z-float-label-notes>
        }
      }
    </div>
  }
} -->

<!-- @let DCLNewId = formGroup()?.controls?.DCLNewId?.value; -->
@let creationDateTime = formGroup()?.controls?.CreationDateTime?.value;
@let completionDateTime = formGroup()?.controls?.CompletionDateTime?.value;
<!-- @let vehicleRegistrationNumber =
    formGroup()?.controls?.Garage?.controls?.VehicleRegistrationNumber?.value ??
    '';

@let subjectId = formGroup()?.controls?.SubjectId?.value ?? ''; -->
@if ((subjects()?.length ?? 0) > 0) {
    <p-select
        optionLabel="PlateNo"
        optionValue="_id"
        class="w-full registration-number-selector"
        [showClear]="false"
        [options]="subjects()"
        [formControlName]="'SubjectId'"
        (onClear)="onRegistrationNumberSelected(undefined)"
        (onChange)="onPlateNoChange($event)"
    />
}
<div
    [formGroup]="$any(formGroup()?.controls?.Garage)"
    class="flex flex-col flex-auto grow gap-4"
>
    <div class="flex flex-col flex-auto">
        @if ((subjects()?.length ?? 0) > 0) {
            <!-- <p-select
                [options]="subjects()"
                [formControlName]="'SubjectId'"
                [showClear]="true"
                (onClear)="onRegistrationNumberSelected(undefined)"
                optionLabel="PlateNo"
                optionValue="_id"
                class="w-full registration-number-selector"
            /> -->
        } @else {
            <p-inputgroup>
                <p-inputgroup-addon
                    ><p-checkbox
                        [formControlName]="'IsForeign'"
                        [binary]="true"
                        [readonly]="creationDateTime != undefined"
                        title="Επιλέξτε αν το αυτοκίνητο έχει αλλοδαπές πινακίδες Κυκλοφορίας"
                /></p-inputgroup-addon>
                <z-float-label-car-plate
                    #floatLabelCarPlate
                    [formControlName]="'VehicleRegistrationNumber'"
                    [readonly]="creationDateTime != undefined"
                    (registrationNumberSelected)="
                        onRegistrationNumberSelected($event)
                    "
                >
                </z-float-label-car-plate>
                <!-- <p-floatlabel variant="on">
            <input
                pInputText
                style="
                    font-size: xx-large;
                    text-align: center;
                    letter-spacing: 0.5rem;
                "
                [readonly]="
                    formGroup()?.controls?.CompletionDateTime?.value !=
                    undefined
                "
                id="z-car-registration-number"
                [formControlName]="'VehicleRegistrationNumber'"
            />

            <label for="z-car-registration-number">Αριθμός Κυκλοφορίας</label>
        </p-floatlabel> -->

                <!-- @if (useFormGroup()?.value?.IsForeign != true) {
            <z-float-label
                [formControlName]="'VehicleRegistrationNumber'"
                [label]="'Αριθμός Κυκλοφορίας Οχήματος'"
            ></z-float-label>
        } @else {
            <z-float-label
                [formControlName]="'ForeignVehicleRegistrationNumber'"
                [label]="'Αριθμός Κυκλοφορίας Οχήματος Αλλοδαπής'"
            ></z-float-label>
        } -->
            </p-inputgroup>
        }
    </div>
</div>
<!-- Ημερομηνία Εισόδου -  Ημερομηνία Εξόδου -->
<div class="flex flex-auto1 grow gap-4 items-center justify-between">
    <div class="flex flex-col w-full gap-2">
        @if (creationDateTime != undefined) {
            <label
                class="flex justify-center label-active-color label-active-font-size label-active-font-weight"
                >Ημερομηνία Εισόδου</label
            >
            <label
                class="flex flex-auto justify-center label-active-font-size-large"
                style="color: var(--p-button-success-background)"
                ><b>{{
                    creationDateTime | zDate: dt.DATETIME_SHORT_WITH_SECONDS
                }}</b></label
            >
        } @else {
            <div class="flex flex-auto">&nbsp;</div>
        }
    </div>
    <div class="flex flex-col items-center w-full">
        <i
            class="pi pi-car"
            style="font-size: 8rem; color: var(--p-button-primary-background)"
        ></i>
    </div>
    <div class="flex flex-col w-full gap-2">
        @if (completionDateTime != undefined) {
            <label
                class="flex justify-center label-active-color label-active-font-size label-active-font-weight"
                >Ημερομηνία Εξόδου</label
            >
            <label
                class="flex flex-auto justify-center label-active-font-size-large"
                style="color: var(--p-button-success-background)"
                ><b>{{
                    completionDateTime | zDate: dt.DATETIME_SHORT_WITH_SECONDS
                }}</b></label
            >
        } @else {
            <!-- <label
                    class="dcl-card-vehiclie-in-service flex flex-auto justify-center"
                    ><b>Σε Εξέλιξη</b></label
                > -->

            @if (creationDateTime != undefined) {
                @if (completionDateTime == undefined) {
                    <p-button
                        label="Εργασίες Σε Εξέλιξη"
                        [rounded]="false"
                        [outlined]="true"
                        [text]="true"
                        [style]="{ height: '45px' }"
                        severity="warn"
                    />
                } @else {
                    <!-- <p-button
                        label="Είσοδος Οχήματος"
                        [rounded]="true"
                        severity="success"
                        [style]="{ width: '120px', height: '45px' }"
                        [disabled]="vehicleRegistrationNumber.length < 4"
                    /> -->
                }
            }
        }
    </div>
</div>

<div
    [formGroup]="$any(formGroup()?.controls?.Garage)"
    class="flex flex-col flex-auto grow gap-4"
>
    @if (formGroup()?.controls?.Garage?.controls?.IsForeign?.value == true) {
        <z-float-label
            [formControlName]="'VehicleCategory'"
            [readonly]="
                formGroup()?.controls?.CompletionDateTime?.value != undefined
            "
            label="Κατηγορία Οχήματος"
        ></z-float-label>
        <z-float-label
            [formControlName]="'VehicleFactory'"
            [readonly]="
                formGroup()?.controls?.CompletionDateTime?.value != undefined
            "
            label="Εργοστάσιο Οχήματος"
        ></z-float-label>
    }
</div>
